/* HorizontalNavComponent.js */

'use strict';
const EventEmitter = require('events').EventEmitter;
const Renderer = require('./HorizontalNavRenderer');
const _ = require('lodash');

class HorizontalNavComponent extends EventEmitter {
  constructor(options) {
    super();
    this._renderer = new Renderer(this);
    this._options = _.assign({sort: true}, options);
    this._navOptions = [];
    this._selectedNavValue = undefined;
    this._registerListeners();
  }
  /*******************************************/
  /* START PRIVATE COMPONENT MODEL METHODS */
  /*******************************************/
  _registerListeners() {}
  _unregisterListeners() {}
  /*******************************************/
  /* END PRIVATE COMPONENT MODEL METHODS */
  /* START PUBLIC COMPONENT MODEL METHODS */
  /*******************************************/
  get renderer() {
    return this.getRenderer();
  }
  getRenderer() {
    return this._renderer;
  }
  shutdown() {
    this._unregisterListeners();
    let prom = this._renderer._shutdown();
    this._renderer = undefined;
    return prom;
  }
  get options() {
    return this._options;
  }
  set options(opts) {
    this._options = _.assign({}, this._options, opts);
  }
  setNavOptions(options) {
    this._navOptions = options;
    this._selectedNavValue = null;
    this.renderer.render();
  }
  getNavOptions() {
    return this._navOptions;
  }
  get selectedValue() {
    return this.getSelectedValue();
  }
  set selectedValue(value) {
    this.setSelectedValue(value);
  }
  setSelectedValue(value, silent) {
    let prevSelectedValue = _.clone(this._selectedNavValue);
    if (prevSelectedValue !== value) {
      this._selectedNavValue = value;
      this.emit('ActiveNavItemSelected', prevSelectedValue, value);
      if (!silent) {
        this.emit('NavItemSelected', prevSelectedValue, value);
      }
    }
  }
  getSelectedValue() {
    return this._selectedNavValue;
  }
  /*******************************************/
  /* END COMPONENT MODEL METHODS */
  /* START HANDLER METHODS */
  /*******************************************/

  /*******************************************/
  /* END HANDLER METHODS */
  /* START PRIVATE METHODS */
  /*******************************************/

  /*******************************************/
  /* END PRIVATE METHODS */
  /* START PUBLIC API METHODS */
  /*******************************************/

  /*******************************************/
  /* END PUBLIC API METHODS */
  /*******************************************/
}
module.exports = HorizontalNavComponent;
